/**
 * Trunnion AI - Recent Audit Events Card
 */

import { FileText, Clock } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { useRecentAudit } from '@/hooks/queries/useDashboard';

export function RecentAuditCard() {
  const { data, isLoading } = useRecentAudit(8);

  return (
    <Card padding="none">
      <CardHeader>
        <CardTitle>
          <FileText className="h-4 w-4 inline mr-1.5 text-trunnion-gold-500" />
          Recent Audit Events
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <LoadingSpinner size="sm" />
        ) : data?.events.length === 0 ? (
          <p className="text-sm text-trunnion-slate-400 text-center py-4">
            No recent events
          </p>
        ) : (
          <div className="space-y-1.5">
            {data?.events.map((event) => (
              <div
                key={event.id}
                className="flex items-center gap-3 rounded-lg px-2 py-1.5 text-xs hover:bg-trunnion-slate-800/50"
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <Badge
                      variant={
                        event.eventType.includes('fail') || event.eventType.includes('denied')
                          ? 'error'
                          : event.eventType.includes('complete')
                            ? 'success'
                            : 'default'
                      }
                    >
                      {event.eventType.split('.').pop()}
                    </Badge>
                    <span className="text-trunnion-slate-300 truncate">
                      {event.resourceName}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-trunnion-slate-500 shrink-0">
                  <Clock className="h-3 w-3" />
                  {new Date(event.timestamp).toLocaleTimeString()}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
